import Link from 'gatsby-link';
import styled from 'styled-components';
import { siteAccent, siteAccentBold } from './variables/colors';

export default styled(Link)`
  color: ${siteAccent};
  text-decoration: underline;
  &:hover {
    color: ${siteAccentBold};
  }
  transition: color 0.2s;
`;



// WEBPACK FOOTER //
// ./src/components/styledComponents/InlineLink.js